import { QueryFunctionContext } from '@tanstack/react-query';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { AppCurrency, Language, UUID } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export interface StoreAdminFields {
	shopwareKey?: string;
	smtpEmail?: string;
	smtpPassword?: string;
	smtpHost?: string;
	smtpPort?: number;
}

export interface Store extends BaseEntity {
	name: string;
	domain: string;
	logoUrl: string;
	contactEmail: string;
	contactPhoneNumber: string;
	contactFormDisclaimer: string;
	pdfHeaderUrl: string;
	pdfFooterUrl: string;
	deliveryUrl: string;
	language: Language;
	currency: AppCurrency;
}

export type StoreWithAdminFields = Store & StoreAdminFields;

class StoreApi extends EntityApi<Store> {
	constructor() {
		super(ApiQueryKey.stores);
		this.getWithAdminFields = this.getWithAdminFields.bind(this);
	}

	async getWithAdminFields({
		queryKey,
	}: QueryFunctionContext<[ApiQueryKey, UUID, 'with-admin-fields']>) {
		const [store, adminFieldsResponse] = await Promise.all([
			this.getOneMutation(queryKey[1]),
			httpClient.get<StoreAdminFields>(
				`${queryKey[0]}/${queryKey[1]}/admin-fields`
			),
		]);

		const combinedData: StoreWithAdminFields = {
			...store,
			...adminFieldsResponse.data,
		};

		return combinedData;
	}
}

export default new StoreApi();
